import { useThemeObserver } from '@atlaskit/tokens';
import {
  BaseStyles,
  ThemeProvider as FuegokitThemeProvider,
} from '@fuegokit/react';
import { ColorModeWithAuto } from '@fuegokit/react/lib/components/ThemeProvider/ThemeProvider';
import React, { PropsWithChildren } from 'react';

const colorModes = {
  light: 'day',
  dark: 'night',
  auto: 'auto',
};

export function ThemeProvider({ children }: PropsWithChildren) {
  const { colorMode } = useThemeObserver();

  return (
    <FuegokitThemeProvider
      colorMode={colorModes[colorMode ?? 'light'] as ColorModeWithAuto}
    >
      <BaseStyles />
      {children}
    </FuegokitThemeProvider>
  );
}
